"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockDescriptionProperty = exports.infoBlockDescriptionPropertyDefinition = void 0;
exports.infoBlockDescriptionPropertyDefinition = {
    view: {
        label: 'Section Description',
        hint: 'Brief glimpse that describes the content in a bit more detail. Example: Win the brand new PS5 to dive even deeper into Esports.',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 170,
        },
    ],
    type: 'rich-text',
    multiple: false,
    name: 'info-block-description',
};
const isInfoBlockDescriptionProperty = (prop) => {
    return prop.name === exports.infoBlockDescriptionPropertyDefinition.name;
};
exports.isInfoBlockDescriptionProperty = isInfoBlockDescriptionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1kZXNjcmlwdGlvbi5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stZGVzY3JpcHRpb24ucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQ0FBc0MsR0FBRztJQUNwRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUscUJBQXFCO1FBQzVCLElBQUksRUFBRSxpSUFBaUk7S0FDeEk7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxHQUFHO1NBQ2Q7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHdCQUF3QjtDQUNDLENBQUE7QUFJMUIsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLElBQWtCLEVBQXdDLEVBQUU7SUFDekcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhDQUFzQyxDQUFDLElBQUksQ0FBQTtBQUNsRSxDQUFDLENBQUE7QUFGWSxRQUFBLDhCQUE4QixrQ0FFMUMifQ==